export default __webpack_public_path__ + "static/media/1764.ac887a78.png";